import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Actions} from '../../../../common/actions';
import Loader from '../../../../common/components/loader';
import './references.scss';

export const MAXFILESIZE = '50MB';

class References extends Component {
  componentDidMount() {
    const {code, dealerEdit} = this.props;
    this.props.getWarrantyAdminImages(code, dealerEdit);
  }

  onDownloadFile = (position) => {
    const {rawImages} = this.props;
    const fileInBase64 = rawImages[position].file;
    const filename = rawImages[position].name;

    const pdfs = atob(fileInBase64);
    const len = pdfs.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      bytes[i] = pdfs.charCodeAt(i);
    }
    this.saveDowloadedData(bytes.buffer, filename);
  };

  saveDowloadedData = (data, filename) => {
    const a = document.createElement('a');
    document.body.appendChild(a);
    a.style = 'display: none';
    const blob = new Blob([data], {'type': 'octet/stream'});
    const url = window.URL.createObjectURL(blob);

    a.href = url;
    a.download = filename;
    a.click();
    window.URL.revokeObjectURL(url);
  };

  render() {
    const {rawImages, imagesLoading} = this.props;

    if (imagesLoading) {
      return (
        <div className='twc-loader-subcontracts'>
          <Loader />
        </div>
      );
    }

    if (rawImages && rawImages.length > 0) {
      return (
        <div className='warranty-container-references'>
          {rawImages &&
            rawImages.map((file, idx) => (
              <p
                key={idx}
                style={{'textAlign': 'center'}}
                className='link'
                onClick={() => this.onDownloadFile(idx)}
              >
                {file.name}
              </p>
            ))}
        </div>
      );
    }

    return (
      <div className='warranty-container-references'>
        <h3>No se encuentran adjuntos disponibles</h3>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'images': state.warrantyAdminImages.images,
    'rawImages': state.warrantyAdminImages.rawImages,
    'imagesLoading': state.warrantyAdminImages.loading,
  };
};

const {getWarrantyAdminImages} = Actions;

const mapDispatchToProps = {
  getWarrantyAdminImages,
};

export default connect(mapStateToProps, mapDispatchToProps)(References);
